$(document).ready(function() {
    
$('.banner-lists').slick({
slidesToShow: 1,
infinite: true,
slidesToScroll: 1,
dots: true,
arrows: false,
autoplay:true,
autoplaySpeed:5000,
focusOnSelect: true,
responsive: [
{
    breakpoint: 550,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
]
});

$('.brand-section .brandSlider').slick({
slidesToShow: 6,
infinite: true,
slidesToScroll: 1,
dots: false,
arrows: false,
autoplay:true,
autoplaySpeed:5000,
focusOnSelect: true,
responsive: [
    {
        breakpoint: 1320,
        settings: {
            slidesToShow: 5,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 992,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 550,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 480,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        }
    },
    {
        breakpoint: 360,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
]
});

$(".reviews-lists").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    dots: false,
     responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $(".featured-slider .product-list, .relatedprdctSlider .product-list").slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      }
    ]
  });

});



 // tabbed content
  // http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });
  
  /* if in tab mode */
  $("ul.tabs li").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var activeTab = $(this).attr("rel");
    $(parent).find("#"+activeTab).fadeIn();
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(this).addClass("active");
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
    
    $('.product-list').slick('refresh');
  
  });
  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    var parent = $(this).parents('.tab-container');
  
    $(parent).find(".tab_content").hide();
    var d_activeTab = $(this).attr("rel");
    $(parent).find("#"+d_activeTab).fadeIn();
  
    $(parent).find(".tab_drawer_heading").removeClass("d_active");
    $(this).addClass("d_active");
  
    $(parent).find("ul.tabs li").removeClass("active");
    $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

    $('.product-list').slick('refresh');
  });
  
  $(".coll-tags").removeClass('show-tags');
   $(".coll-tags .button").on('click',function(e){
     e.preventDefault();
	  $(".tags").slideToggle(300);
   });
  /* Extra class "tab_last"
     to add border to right side
     of last tab */
  $('ul.tabs li').last().addClass("tab_last");


  // mobile Tab
  $(document).off('click', '.select-label').on('click', '.select-label', function (e) {
    e.preventDefault();
      if($(this).parent().hasClass('active')){
        $(this).parent().removeClass('active');
      }else{
        $('.dropdown').removeClass('active');
        $(this).parent().addClass('active');
      }
  });
  $(document).on('click','.dropdown-list li', function () {
      $(this).parents('.dropdown').find('.select-label_inner').text($(this).text());
      $(this).parents('.dropdown').removeClass('active');
      var variant_id = $(this).data('value');
      $(this).parents('.main_variant_div').parent().find('.product-variant-id').val(variant_id);
  });


// drawer menu issue fixed
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.mobile-nav__toggle button.collapsible-trigger');

  if (btn) {
    btn.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');

    // find closest collapsible-content
    const parent = btn.closest('.mobile-nav__item.appear-animation');

    if (parent) {
      const backBtn = parent.querySelector('.menubackBtn');

      if (backBtn) {
        backBtn.classList.add('is-open');
        backBtn.setAttribute('aria-expanded', 'true');

        const sublist = backBtn.nextElementSibling;
        if (sublist && sublist.classList.contains('mobile-nav__sublist')) {
          const grandchild = sublist.querySelectorAll("button.collapsible-trigger:not(.menubackBtn)");

          grandchild.forEach(child => {
            child.classList.remove('is-open');
            child.setAttribute('aria-expanded', 'false');

            child.addEventListener('click', function () {

              child.classList.remove('is-open');
              child.setAttribute('aria-expanded', 'false');

              const grandParent = child.closest('.mobile-nav__item');
              if (grandParent) {
                const grandSublistBack = grandParent.querySelector(".mobile-nav__sublist button.collapsible-trigger.menubackBtn");
                if (grandSublistBack) {
                  grandSublistBack.classList.add('is-open');
                  grandSublistBack.setAttribute('aria-expanded', 'true');
                }
              }

            });
          });
        }

      }
    }
  }
});



document.addEventListener('DOMContentLoaded', function () {

  const stickyBar = document.getElementById('sticky-atc');

  if (!stickyBar) return;

  const paymentButtons = document.querySelector('.payment-buttons');

  const productForm = document.querySelector('form[action="/cart/add"]');

  const stickyButton = document.getElementById('StickyAddToCart');

  const stickyVariant = document.getElementById('StickyVariantSelect');

  if (!paymentButtons || !productForm) return;

  // Show/hide sticky ATC
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyBar.classList.remove('show');
      } else {
        stickyBar.classList.add('show');
        stickyBar.classList.remove('hidden');
      }
    },
    {
      threshold: 0
    }
  );

  observer.observe(paymentButtons);

  // Sync variant dropdown with main form
  if (stickyVariant) {

    stickyVariant.addEventListener('change', function () {

      const mainVariantInput = productForm.querySelector('[name="id"]');

      if (mainVariantInput) {
        mainVariantInput.value = this.value;
        mainVariantInput.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }
    });

    // Keep sticky dropdown synced with main variant
    document.addEventListener('change', function(e) {

      const variantInput = e.target.closest('[name="id"], [data-variant-input]');

      if (!variantInput) return;

      setTimeout(() => {

        const currentVariantId =
          productForm.querySelector('[name="id"]').value;

        stickyVariant.value = currentVariantId;

      }, 100);

    });
  }

  // Add to cart
  stickyButton.addEventListener('click', function () {

    const formData = new FormData(productForm);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(res => res.json())
    .then(data => {

      stickyButton.textContent = 'Added ✓';

      setTimeout(() => {
        stickyButton.textContent = 'Add To Cart';
      }, 2000);

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        }
      }));

    })
    .catch(err => {
      console.error(err);
      alert('Error adding to cart');
    });

  });

});



/**
 * Free Shipping Bar – live updater
 *
 * Listens for the Impulse theme's built-in cart events and
 * re-calculates the progress bar without a page reload.
 *
 * Events listened for:
 *   cart:updated  – fired by CartForm after every qty change
 *   ajaxProduct:added – fired when a product is added via Ajax
 */

(function () {
  'use strict';

  // Reads threshold (in cents) from the bar element's data attribute.
  // Falls back to 0 so the bar gracefully stays at 100% if misconfigured.
  function getThreshold(barEl) {
    return parseInt(barEl.dataset.threshold, 10) || 0;
  }

  /**
   * Build the remaining-text from the template stored in the bar's
   * sibling data element, or fall back to a sensible default.
   */
  function formatMoney(cents) {
    // Re-use the theme's own formatter when available
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    // Plain fallback
    return '$' + (cents / 100).toFixed(2);
  }

  /**
   * Update a single bar element given the current cart total (in cents).
   */
  function updateBar(barEl, totalCents) {
    var threshold  = getThreshold(barEl);
    if (!threshold) return;

    var remaining  = threshold - totalCents;
    var progress   = Math.min(Math.round((totalCents / threshold) * 100), 100);
    var achieved   = remaining <= 0;

    // -- toggle achieved class
    barEl.classList.toggle('free-shipping-bar--achieved', achieved);

    // -- update progress bar fill
    var fill = barEl.querySelector('.free-shipping-bar__fill');
    if (fill) {
      fill.style.width = progress + '%';
      fill.dataset.progress = progress;
    }

    // -- update track aria
    var track = barEl.querySelector('.free-shipping-bar__track');
    if (track) {
      track.setAttribute('aria-valuenow', progress);
    }

    // -- swap message text
    var msg = barEl.querySelector('.free-shipping-bar__message');
    if (!msg) return;

    if (achieved) {
      // Pull achieved text from a data attribute set by Liquid
      var achievedText = barEl.dataset.achievedText || "🎉 You've unlocked free shipping!";
      msg.textContent = achievedText;
      msg.classList.remove('free-shipping-bar__message--remaining');
      msg.classList.add('free-shipping-bar__message--achieved');
    } else {
      var remainingTemplate = barEl.dataset.remainingText || 'Spend [amount] more to get free shipping';
      var displayText = remainingTemplate.replace('[amount]', formatMoney(remaining));
      msg.innerHTML = displayText;
      msg.classList.remove('free-shipping-bar__message--achieved');
      msg.classList.add('free-shipping-bar__message--remaining');
    }
  }

  /**
   * Find all bars on the page and refresh them.
   */
  function refreshAllBars(totalCents) {
    document.querySelectorAll('.free-shipping-bar').forEach(function (barEl) {
      updateBar(barEl, totalCents);
    });
  }

  /**
   * Fetch current cart total and trigger a refresh.
   */
  function fetchAndRefresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshAllBars(cart.total_price);
      })
      .catch(function (err) {
        console.warn('[FreeShippingBar] cart fetch failed', err);
      });
  }

  // ---- Event listeners ----

  // Fired by CartForm.quantityChanged after a successful cart change
  document.addEventListener('cart:updated', function (evt) {
    var cart = evt && evt.detail && evt.detail.cart;
    if (cart && typeof cart.total_price !== 'undefined') {
      refreshAllBars(cart.total_price);
    } else {
      fetchAndRefresh();
    }
  });

  // Fired by AjaxProduct / CartDrawer when a product is added
  document.addEventListener('ajaxProduct:added', function () {
    fetchAndRefresh();
  });

  // Also refresh when the cart drawer opens so the bar is correct
  // for any changes made outside the drawer
  document.addEventListener('drawerOpen', function () {
    fetchAndRefresh();
  });

})();







// (function () {

//   'use strict';

//   /*
//   |--------------------------------------------------------------------------
//   | GLOBAL LAST PRODUCT ID
//   |--------------------------------------------------------------------------
//   */

//   let LAST_ADDED_PRODUCT_ID = null;

//   /*
//   |--------------------------------------------------------------------------
//   | Slick Config
//   |--------------------------------------------------------------------------
//   */

//   const SLICK_CONFIG = {
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     arrows: true,
//     dots: false,
//     infinite: false,
//     adaptiveHeight: true,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1
//         }
//       }
//     ]
//   };

//   /*
//   |--------------------------------------------------------------------------
//   | Get Cart
//   |--------------------------------------------------------------------------
//   */

//   function getCart() {

//     return fetch('/cart.js', {
//       credentials: 'same-origin'
//     })
//     .then(function (response) {
//       return response.json();
//     });

//   }

//   /*
//   |--------------------------------------------------------------------------
//   | Money Formatter
//   |--------------------------------------------------------------------------
//   */

//   function formatMoney(cents) {

//     if (
//       window.Shopify &&
//       Shopify.formatMoney
//     ) {
//       return Shopify.formatMoney(cents);
//     }

//     return '$' + (cents / 100).toFixed(2);

//   }

//   /*
//   |--------------------------------------------------------------------------
//   | Init Slider
//   |--------------------------------------------------------------------------
//   */

//   function initSlider(slider) {

//     if (!window.jQuery) return;

//     const $slider = window.jQuery(slider);

//     if ($slider.hasClass('slick-initialized')) {
//       $slider.slick('unslick');
//     }

//     setTimeout(function () {

//       $slider.slick(SLICK_CONFIG);

//     }, 300);

//   }

//   /*
//   |--------------------------------------------------------------------------
//   | Load Recommendations
//   |--------------------------------------------------------------------------
//   */

//   function loadRecommendations(productId) {

//     if (!productId) return;

//     console.log(
//       '[Cart Rec] Product ID:',
//       productId
//     );

//     fetch(
//       `/recommendations/products.json?product_id=${productId}&limit=8&intent=related`,
//       {
//         credentials: 'same-origin'
//       }
//     )
//     .then(function (response) {
//       return response.json();
//     })
//     .then(function (data) {

//       console.log(
//         '[Cart Rec] API Response:',
//         data
//       );

//       if (
//         !data.products ||
//         !data.products.length
//       ) {

//         console.warn(
//           '[Cart Rec] No recommendations'
//         );

//         return;

//       }

//       getCart().then(function (cart) {

//         const cartProductIds =
//           cart.items.map(function (item) {
//             return item.product_id;
//           });

//         document
//           .querySelectorAll('.cart-rec__wrap')
//           .forEach(function (wrap) {

//             const slider =
//               wrap.querySelector('.cart-rec__slider');

//             if (!slider) return;

//             slider.innerHTML = '';

//             let visibleCount = 0;

//             data.products.forEach(function (product) {

//               /*
//               |--------------------------------------------------------------------------
//               | Hide products already in cart
//               |--------------------------------------------------------------------------
//               */

//               if (
//                 cartProductIds.includes(product.id)
//               ) {
//                 return;
//               }

//               visibleCount++;

//               const image =
//                 product.featured_image
//                   ? product.featured_image
//                   : '';

//               const html = `
//               <div
//                 class="grid-product"
//                 data-product-id="${product.id}"
//                 data-product-handle="${product.handle}"
//               >

//                 <a
//                   href="${product.url}"
//                   class="grid-product__link"
//                 >

//                   ${
//                     image
//                       ? `
//                         <div class="grid-product__image-mask">
//                           <img
//                             src="${image}"
//                             alt="${product.title}"
//                             loading="lazy"
//                           >
//                         </div>
//                       `
//                       : ''
//                   }

//                   <div class="grid-product__meta">

//                     <div class="grid-product__title">
//                       ${product.title}
//                     </div>

//                     <div class="grid-product__price">
//                       ${formatMoney(product.price)}
//                     </div>

//                   </div>

//                 </a>

//                 <div class="cart-rec__actions"></div>

//               </div>
//             `;
//               const temp =
//                 document.createElement('div');

//               temp.innerHTML = html;

//               const card =
//                 temp.firstElementChild;

//               injectATC(card, product);

//               slider.appendChild(card);

//             });

//             if (!visibleCount) {

//               wrap.style.display = 'none';

//               return;

//             }

//             wrap.style.display = 'block';

//             initSlider(slider);

//           });

//       });

//     })
//     .catch(function (error) {

//       console.error(
//         '[Cart Rec]',
//         error
//       );

//     });

//   }

//   /*
//   |--------------------------------------------------------------------------
//   | Inject Add To Cart
//   |--------------------------------------------------------------------------
//   */

//   function injectATC(card, product) {

//     if (!product) return;

//     const variants =
//       product.variants || [];

//     if (!variants.length) return;

//     let selectHTML = '';

//     /*
//     |--------------------------------------------------------------------------
//     | Variant Selector
//     |--------------------------------------------------------------------------
//     */

//     if (variants.length > 1) {

//       selectHTML += `
//         <select class="cart-rec__variant">
//       `;

//       variants.forEach(function (variant) {

//         selectHTML += `
//           <option
//             value="${variant.id}"
//             ${!variant.available ? 'disabled' : ''}
//           >
//             ${variant.title}
//             ${!variant.available ? ' - Sold Out' : ''}
//           </option>
//         `;

//       });

//       selectHTML += `
//         </select>
//       `;
//     }

//     /*
//     |--------------------------------------------------------------------------
//     | First Available Variant
//     |--------------------------------------------------------------------------
//     */

//     const firstVariant =
//       variants.find(function (variant) {
//         return variant.available;
//       }) || variants[0];

//     /*
//     |--------------------------------------------------------------------------
//     | Wrapper
//     |--------------------------------------------------------------------------
//     */

//     const wrapper =
//       document.createElement('div');

//     wrapper.className =
//       'cart-rec__atc-wrap';

//     wrapper.innerHTML = `
//       ${selectHTML}

//       <button
//         class="btn cart-rec__atc"
//         data-variant-id="${firstVariant.id}"
//         ${!firstVariant.available ? 'disabled' : ''}
//       >
//         ${
//           firstVariant.available
//             ? 'Add to Cart'
//             : 'Sold Out'
//         }
//       </button>
//     `;

//     const target =
//       card.querySelector('.cart-rec__actions');

//     if (target) {
//       target.appendChild(wrapper);
//     }

//     /*
//     |--------------------------------------------------------------------------
//     | Variant Change
//     |--------------------------------------------------------------------------
//     */

//     const select =
//       wrapper.querySelector('select');

//     const button =
//       wrapper.querySelector('button');

//     if (select && button) {

//       select.addEventListener(
//         'change',
//         function () {

//           const option =
//             select.options[
//               select.selectedIndex
//             ];

//           button.dataset.variantId =
//             option.value;

//           button.disabled =
//             option.disabled;

//           button.textContent =
//             option.disabled
//               ? 'Sold Out'
//               : 'Add to Cart';

//         }
//       );

//     }

//   }

//   /*
//   |--------------------------------------------------------------------------
//   | Add To Cart
//   |--------------------------------------------------------------------------
//   */

//   document.addEventListener(
//     'click',
//     function (event) {

//       const button =
//         event.target.closest('.cart-rec__atc');

//       if (!button) return;

//       event.preventDefault();

//       const variantId =
//         parseInt(
//           button.dataset.variantId,
//           10
//         );

//       if (!variantId) return;

//       button.disabled = true;

//       button.textContent = 'Adding...';

//       fetch('/cart/add.js', {
//         method: 'POST',
//         credentials: 'same-origin',
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json'
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: 1
//         })
//       })
//       .then(function (response) {
//         return response.json();
//       })
//       .then(function (item) {

//         console.log(
//           '[Cart Rec] Added:',
//           item
//         );

//         button.textContent = 'Added';

//         /*
//         |--------------------------------------------------------------------------
//         | REAL LAST ADDED PRODUCT
//         |--------------------------------------------------------------------------
//         */

//         LAST_ADDED_PRODUCT_ID =
//           item.product_id;

//         /*
//         |--------------------------------------------------------------------------
//         | Refresh Recommendations
//         |--------------------------------------------------------------------------
//         */

//         setTimeout(function () {

//           loadRecommendations(
//             LAST_ADDED_PRODUCT_ID
//           );

//         }, 900);

//         /*
//         |--------------------------------------------------------------------------
//         | Theme Events
//         |--------------------------------------------------------------------------
//         */

//         document.dispatchEvent(
//           new CustomEvent(
//             'ajaxProduct:added',
//             {
//               detail: {
//                 product: item
//               }
//             }
//           )
//         );

//         document.dispatchEvent(
//           new CustomEvent('cart:build')
//         );

//       })
//       .catch(function (error) {

//         console.error(error);

//         button.disabled = false;

//         button.textContent = 'Error';

//       });

//     }
//   );

//   /*
//   |--------------------------------------------------------------------------
//   | Impulse Theme Add To Cart Event
//   |--------------------------------------------------------------------------
//   */

//   document.addEventListener(
//     'ajaxProduct:added',
//     function (event) {

//       console.log(
//         '[Cart Rec] ajaxProduct:added',
//         event
//       );

//       const product =
//         event.detail &&
//         event.detail.product;

//       if (!product) return;

//       LAST_ADDED_PRODUCT_ID =
//         product.product_id ||
//         product.id;

//       console.log(
//         '[Cart Rec] LAST_ADDED_PRODUCT_ID:',
//         LAST_ADDED_PRODUCT_ID
//       );

//       if (!LAST_ADDED_PRODUCT_ID) return;

//       setTimeout(function () {

//         loadRecommendations(
//           LAST_ADDED_PRODUCT_ID
//         );

//       }, 900);

//     }
//   );

//   /*
//   |--------------------------------------------------------------------------
//   | Init Recommendations
//   |--------------------------------------------------------------------------
//   */

//   function initRecommendations() {

//     /*
//     |--------------------------------------------------------------------------
//     | Use actual AJAX product first
//     |--------------------------------------------------------------------------
//     */

//     if (LAST_ADDED_PRODUCT_ID) {

//       loadRecommendations(
//         LAST_ADDED_PRODUCT_ID
//       );

//       return;

//     }

//     /*
//     |--------------------------------------------------------------------------
//     | Fallback Cart Item
//     |--------------------------------------------------------------------------
//     */

//     getCart().then(function (cart) {

//       if (
//         !cart.items ||
//         !cart.items.length
//       ) {
//         return;
//       }

//       /*
//       |--------------------------------------------------------------------------
//       | IMPULSE reverses cart order
//       |--------------------------------------------------------------------------
//       */

//       const latestItem =
//         cart.items[0];

//       if (!latestItem) return;

//       LAST_ADDED_PRODUCT_ID =
//         latestItem.product_id;

//       console.log(
//         '[Cart Rec] Initial Product:',
//         LAST_ADDED_PRODUCT_ID
//       );

//       loadRecommendations(
//         LAST_ADDED_PRODUCT_ID
//       );

//     });

//   }

//   /*
//   |--------------------------------------------------------------------------
//   | DOM Ready
//   |--------------------------------------------------------------------------
//   */

//   document.addEventListener(
//     'DOMContentLoaded',
//     function () {

//       initRecommendations();

//     }
//   );

//   /*
//   |--------------------------------------------------------------------------
//   | Drawer Open
//   |--------------------------------------------------------------------------
//   */

//   document.addEventListener(
//     'drawerOpen',
//     function () {

//       console.log(
//         '[Cart Rec] Drawer Open'
//       );

//       setTimeout(function () {

//         initRecommendations();

//         if (
//           window.jQuery &&
//           $('.cart-rec__slider').hasClass('slick-initialized')
//         ) {
//           $('.cart-rec__slider').slick('setPosition');
//         }

//       }, 900);

//     }
//   );

  

// })();

(function () {

  'use strict';

  /*
  |--------------------------------------------------------------------------
  | GLOBAL LAST PRODUCT ID
  |--------------------------------------------------------------------------
  */

  let LAST_ADDED_PRODUCT_ID = null;

  /*
  |--------------------------------------------------------------------------
  | Slick Config
  |--------------------------------------------------------------------------
  */
let SLICK_CONFIG;
if ($('body').hasClass('template-cart')) {
  SLICK_CONFIG = {
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
}else{
  SLICK_CONFIG = {
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
}
  /*
  |--------------------------------------------------------------------------
  | Get Cart
  |--------------------------------------------------------------------------
  */

  function getCart() {

    return fetch('/cart.js', {
      credentials: 'same-origin'
    })
    .then(function (response) {
      return response.json();
    });

  }

  /*
  |--------------------------------------------------------------------------
  | Money Formatter
  |--------------------------------------------------------------------------
  */

  function formatMoney(cents) {

    if (
      window.Shopify &&
      Shopify.formatMoney
    ) {
      return Shopify.formatMoney(cents);
    }

    return '$' + (cents / 100).toFixed(2);

  }

  /*
  |--------------------------------------------------------------------------
  | Init Slider
  |--------------------------------------------------------------------------
  */

  function initSlider(slider) {

    if (!window.jQuery) return;

    const $slider = window.jQuery(slider);

    /*
    |--------------------------------------------------------------------------
    | Destroy old slick first
    |--------------------------------------------------------------------------
    */

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    setTimeout(function () {

      $slider.slick(SLICK_CONFIG);

    }, 200);

  }

  /*
  |--------------------------------------------------------------------------
  | Load Recommendations
  |--------------------------------------------------------------------------
  */

  function loadRecommendations(productId) {

    if (!productId) return;

    // console.log(
    //   '[Cart Rec] Product ID:',
    //   productId
    // );

    fetch(
      `/recommendations/products.json?product_id=${productId}&limit=8&intent=related`,
      {
        credentials: 'same-origin'
      }
    )
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {

      // console.log(
      //   '[Cart Rec] API Response:',
      //   data
      // );

      if (
        !data.products ||
        !data.products.length
      ) {

        console.warn(
          '[Cart Rec] No recommendations'
        );

        return;

      }

      getCart().then(function (cart) {

        const cartProductIds =
          cart.items.map(function (item) {
            return item.product_id;
          });

        document
          .querySelectorAll('.cart-rec__wrap')
          .forEach(function (wrap) {

            const slider =
              wrap.querySelector('.cart-rec__slider');

            if (!slider) return;

            /*
            |--------------------------------------------------------------------------
            | IMPORTANT FIX
            |--------------------------------------------------------------------------
            */

            if (
              window.jQuery &&
              window.jQuery(slider).hasClass('slick-initialized')
            ) {
              window.jQuery(slider).slick('unslick');
            }

            slider.innerHTML = '';

            let visibleCount = 0;

            data.products.forEach(function (product) {

              /*
              |--------------------------------------------------------------------------
              | Hide products already in cart
              |--------------------------------------------------------------------------
              */

              if (
                cartProductIds.includes(product.id)
              ) {
                return;
              }

              visibleCount++;

              const image =
                product.featured_image
                  ? product.featured_image
                  : '';

              const variants = product.variants || [];

              let selectHTML = '';

              /*
              |--------------------------------------------------------------------------
              | Variant Selector
              |--------------------------------------------------------------------------
              */

              if (variants.length > 1) {

                selectHTML += `
                  <select class="cart-rec__variant">
                `;

                variants.forEach(function (variant) {

                  selectHTML += `
                    <option
                      value="${variant.id}"
                      ${!variant.available ? 'disabled' : ''}
                    >
                      ${variant.title}
                      ${!variant.available ? ' - Sold Out' : ''}
                    </option>
                  `;

                });

                selectHTML += `
                  </select>
                `;
              }

              const html = `
                <div
                  class="grid-product"
                  data-product-id="${product.id}"
                  data-product-handle="${product.handle}"
                >

                  <a
                    href="${product.url}"
                    class="grid-product__link"
                  >

                    ${
                      image
                        ? `
                          <div class="grid-product__image-mask">
                            <img
                              src="${image}"
                              alt="${product.title}"
                              loading="lazy"
                            >
                          </div>
                        `
                        : ''
                    }

                    <div class="grid-product__meta">

                      <div class="grid-product__title">
                        ${product.title}
                      </div>

                      <div class="grid-product__price">
                        ${formatMoney(product.price)}
                      </div>

                      ${selectHTML}

                    </div>

                  </a>

                  <div class="cart-rec__actions"></div>

                </div>
              `;

              const temp =
                document.createElement('div');

              temp.innerHTML = html;

              const card =
                temp.firstElementChild;

              injectATC(card, product);

              slider.appendChild(card);

            });

            if (!visibleCount) {

              wrap.style.display = 'none';

              return;

            }

            wrap.style.display = 'block';

            initSlider(slider);

          });

      });

    })
    .catch(function (error) {

      console.error(
        '[Cart Rec]',
        error
      );

    });

  }

  /*
  |--------------------------------------------------------------------------
  | Inject Add To Cart
  |--------------------------------------------------------------------------
  */

  function injectATC(card, product) {

    if (!product) return;

    const variants =
      product.variants || [];

    if (!variants.length) return;

    //let selectHTML = '';

    /*
    |--------------------------------------------------------------------------
    | Variant Selector
    |--------------------------------------------------------------------------
    */

    // if (variants.length > 1) {

    //   selectHTML += `
    //     <select class="cart-rec__variant">
    //   `;

    //   variants.forEach(function (variant) {

    //     selectHTML += `
    //       <option
    //         value="${variant.id}"
    //         ${!variant.available ? 'disabled' : ''}
    //       >
    //         ${variant.title}
    //         ${!variant.available ? ' - Sold Out' : ''}
    //       </option>
    //     `;

    //   });

    //   selectHTML += `
    //     </select>
    //   `;
    // }

    /*
    |--------------------------------------------------------------------------
    | First Available Variant
    |--------------------------------------------------------------------------
    */

    const firstVariant =
      variants.find(function (variant) {
        return variant.available;
      }) || variants[0];

    /*
    |--------------------------------------------------------------------------
    | Wrapper
    |--------------------------------------------------------------------------
    */

    const wrapper =
      document.createElement('div');

    wrapper.className =
      'cart-rec__atc-wrap';

    wrapper.innerHTML = `
      

      <button
        class="btn cart-rec__atc"
        data-variant-id="${firstVariant.id}"
        ${!firstVariant.available ? 'disabled' : ''}
      >
        ${
          firstVariant.available
            ? 'Add to Cart'
            : 'Sold Out'
        }
      </button>
    `;

    const target =
      card.querySelector('.cart-rec__actions');

    if (target) {
      target.appendChild(wrapper);
    }

    /*
    |--------------------------------------------------------------------------
    | Variant Change
    |--------------------------------------------------------------------------
    */

    const select =
      wrapper.querySelector('select');

    const button =
      wrapper.querySelector('button');

    if (select && button) {

      select.addEventListener(
        'change',
        function () {

          const option =
            select.options[
              select.selectedIndex
            ];

          button.dataset.variantId =
            option.value;

          button.disabled =
            option.disabled;

          button.textContent =
            option.disabled
              ? 'Sold Out'
              : 'Add to Cart';

        }
      );

    }

  }

  /*
  |--------------------------------------------------------------------------
  | Add To Cart
  |--------------------------------------------------------------------------
  */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest('.cart-rec__atc');

      if (!button) return;

      event.preventDefault();

      const variantId =
        parseInt(
          button.dataset.variantId,
          10
        );

      if (!variantId) return;

      button.disabled = true;

      button.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(function (response) {

        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        return response.json();

      })
      .then(function (item) {

        // console.log(
        //   '[Cart Rec] Added:',
        //   item
        // );

        button.textContent = 'Added';

        /*
        |--------------------------------------------------------------------------
        | REAL LAST ADDED PRODUCT
        |--------------------------------------------------------------------------
        */

        LAST_ADDED_PRODUCT_ID =
          item.product_id;

        /*
        |--------------------------------------------------------------------------
        | Trigger Theme Event
        |--------------------------------------------------------------------------
        */

        document.dispatchEvent(
          new CustomEvent(
            'ajaxProduct:added',
            {
              detail: {
                product: item
              }
            }
          )
        );

        /*
        |--------------------------------------------------------------------------
        | Wait for drawer rebuild
        |--------------------------------------------------------------------------
        */

        setTimeout(function () {

          loadRecommendations(
            LAST_ADDED_PRODUCT_ID
          );

          document
            .querySelectorAll('.cart-rec__slider')
            .forEach(function (slider) {

              if (
                window.jQuery &&
                window.jQuery(slider).hasClass('slick-initialized')
              ) {
                window.jQuery(slider).slick('unslick');
              }

              initSlider(slider);

            });

        }, 1200);

      })
      .catch(function (error) {

        console.error(error);

        button.disabled = false;

        button.textContent = 'Error';

      });

    }
  );

  /*
  |--------------------------------------------------------------------------
  | Impulse Theme Add To Cart Event
  |--------------------------------------------------------------------------
  */

  document.addEventListener(
    'ajaxProduct:added',
    function (event) {

      // console.log(
      //   '[Cart Rec] ajaxProduct:added',
      //   event
      // );

      const product =
        event.detail &&
        event.detail.product;

      if (!product) return;

      LAST_ADDED_PRODUCT_ID =
        product.product_id ||
        product.id;

      // console.log(
      //   '[Cart Rec] LAST_ADDED_PRODUCT_ID:',
      //   LAST_ADDED_PRODUCT_ID
      // );

    }
  );

  /*
  |--------------------------------------------------------------------------
  | Init Recommendations
  |--------------------------------------------------------------------------
  */

  function initRecommendations() {

    /*
    |--------------------------------------------------------------------------
    | Use actual AJAX product first
    |--------------------------------------------------------------------------
    */

    if (LAST_ADDED_PRODUCT_ID) {

      loadRecommendations(
        LAST_ADDED_PRODUCT_ID
      );

      return;

    }

    /*
    |--------------------------------------------------------------------------
    | Fallback Cart Item
    |--------------------------------------------------------------------------
    */

    getCart().then(function (cart) {

      if (
        !cart.items ||
        !cart.items.length
      ) {
        return;
      }

      /*
      |--------------------------------------------------------------------------
      | IMPULSE reverses cart order
      |--------------------------------------------------------------------------
      */

      const latestItem =
        cart.items[0];

      if (!latestItem) return;

      LAST_ADDED_PRODUCT_ID =
        latestItem.product_id;

      // console.log(
      //   '[Cart Rec] Initial Product:',
      //   LAST_ADDED_PRODUCT_ID
      // );

      loadRecommendations(
        LAST_ADDED_PRODUCT_ID
      );

    });

  }

  /*
  |--------------------------------------------------------------------------
  | DOM Ready
  |--------------------------------------------------------------------------
  */

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      initRecommendations();

    }
  );

  /*
  |--------------------------------------------------------------------------
  | Drawer Open
  |--------------------------------------------------------------------------
  */

  document.addEventListener(
    'drawerOpen',
    function () {

      // console.log(
      //   '[Cart Rec] Drawer Open'
      // );

      setTimeout(function () {

        initRecommendations();

        document
          .querySelectorAll('.cart-rec__slider')
          .forEach(function (slider) {

            if (
              window.jQuery &&
              window.jQuery(slider).hasClass('slick-initialized')
            ) {
              window.jQuery(slider).slick('setPosition');
            }

          });

      }, 900);

    }
  );

})();
